import { HistoryEditor } from 'slate-history';

const typingMergeWindow = 700;

function endsCurrentWord(operation) {

  if (operation.type !== 'insert_text') {
    return false;
  }

  return /\s/.test(operation.text);

}

function withGroupedHistory(editor) {

  const apply = editor.apply.bind(editor);

  let lastApplyTime = 0;
  let previousOperationEndedWord = false;

  editor.apply = function applyWithGroupedHistory(operation) {

    const now = Date.now();
    const elapsed = now - lastApplyTime;
    const withinWindow = elapsed < typingMergeWindow;
    const merge = withinWindow === true && previousOperationEndedWord === false;

    lastApplyTime = now;
    previousOperationEndedWord = endsCurrentWord(operation);

    if (merge === true) {
      HistoryEditor.withMerging(editor, function applyMerged() {
        apply(operation);
      });
      return;
    }

    apply(operation);

  };

  return editor;

}

export default withGroupedHistory;
